export class FeatureFlagsService {
    constructor(features) {
        this.features = features;
    }
    isEnabled(feature) {
        return this.features
            .map(ff => ff.toUpperCase())
            .includes(feature.toUpperCase());
    }
}
//# sourceMappingURL=v1.js.map